import React, { useState } from 'react';
import HeaderSection from '../../components/reusableComponents/HeaderSection';
import { Box, Container, Divider, Grid } from '@material-ui/core';
import upi from '../../assets/images/upi.png';
import spice from '../../assets/images/spice.gif';
import credit from '../../assets/images/credit.png';
import icons from '../../assets/images/icons.png';
import paylater from '../../assets/images/paylater.png';
import netbank from '../../assets/images/netbank.png';
import wallet from '../../assets/images/wallet.png';
import emi from '../../assets/images/emi.png';
import TitleText from '../../components/reusableComponents/TitleText';
import BodyText from '../../components/reusableComponents/BodyText';
import CheckoutForm from '../../form/CheckoutForm';
const CheckoutPage = () => {
	const [val, setVal] = useState(2);
	return (
		<>
			<HeaderSection id={1} />
			<Container>
				<Grid container spacing={2} style={{ marginTop: 80 }}>
					<Grid
						item
						xs={12}
						md={8}
						lg={8}
						style={{
							marginTop: 30,
							backgroundColor: '#fff',
							boxShadow: '0 3px 30px 0 rgb(0 0 0 / 10%)',
							borderRadius: 10,
						}}>
						<Grid container spacing={2}>
							<Grid
								item
								xs={12}
								md={4}
								lg={4}
								style={{
									background: '#eaf5ff',
									borderTopLeftRadius: 10,
									borderBottomLeftRadius: 10,
								}}>
								<Box style={{ paddingLeft: 20 }}>
									<TitleText textStyle={{ fontSize: 20, fontWeight: 500 }}>
										Payment Option
									</TitleText>
								</Box>
								<Divider />
								<Box
									onClick={() => setVal(1)}
									display='flex'
									style={{
										padding: 15,
										alignItems: 'center',
										background: val == 1 ? 'white' : '',
										cursor: 'pointer',
									}}>
									<img
										src={upi}
										alt='upi'
										style={{ width: '30px', height: '30px' }}></img>
									<Box ml={'15px'}>
										<TitleText textStyle={{ fontSize: 16 }}>UPI</TitleText>
										<BodyText textStyle={{ fontSize: 12 }}>
											Pay Directly From your Bank Account
										</BodyText>
									</Box>
								</Box>
								<Box
									style={{
										padding: 15,
										background: val == 2 ? 'white' : '',
										cursor: 'pointer',
									}}
									display='flex'
									mt={'10px'}
									onClick={() => setVal(2)}>
									<img
										src={credit}
										alt='credit'
										style={{ width: '30px', height: '30px' }}></img>
									<Box ml={'15px'} style={{ overflow: 'hidden' }}>
										<TitleText textStyle={{ fontSize: 16 }}>
											Credit/Debit/ATM Card
										</TitleText>
										<BodyText
											textStyle={{
												fontSize: 12,
												overflow: 'hidden',
												whiteSpace: 'nowrap',
												textOverflow: 'ellipsis',
											}}>
											Visa,MasterCard,Amex,Rupay And Many More
										</BodyText>
									</Box>
								</Box>
								<Box
									onClick={() => setVal(3)}
									style={{
										padding: 15,
										background: val == 3 ? 'white' : '',
										cursor: 'pointer',
									}}
									display='flex'
									mt={'10px'}>
									<img
										src={paylater}
										alt='credit'
										style={{ width: '30px', height: '30px' }}></img>
									<Box ml={'15px'}>
										<TitleText textStyle={{ fontSize: 16 }}>
											Pay Later
										</TitleText>
										<BodyText textStyle={{ fontSize: 12 }}>
											Lazypay, Simpl, Zestmoney and more
										</BodyText>
									</Box>
								</Box>
								<Box
									onClick={() => setVal(4)}
									style={{
										padding: 15,
										background: val == 4 ? 'white' : '',
										cursor: 'pointer',
									}}
									display='flex'
									mt={'10px'}>
									<img
										src={netbank}
										alt='credit'
										style={{ width: '30px', height: '30px' }}></img>
									<Box ml={'15px'}>
										<TitleText textStyle={{ fontSize: 16 }}>
											Net Banking
										</TitleText>
										<BodyText textStyle={{ fontSize: 12 }}>
											All Major Banks Available
										</BodyText>
									</Box>
								</Box>
								<Box
									onClick={() => setVal(5)}
									style={{
										padding: 15,
										background: val == 5 ? 'white' : '',
										cursor: 'pointer',
									}}
									display='flex'
									mt={'10px'}>
									<img
										src={wallet}
										alt='credit'
										style={{ width: '30px', height: '30px' }}></img>
									<Box ml={'15px'}>
										<TitleText textStyle={{ fontSize: 16 }}>
											TripMoney, Gift Cards, Wallets & More
										</TitleText>
										<BodyText textStyle={{ fontSize: 12 }}>
											Gift cards, Mobikwik, AmazonPay
										</BodyText>
									</Box>
								</Box>
								<Box
									onClick={() => setVal(6)}
									style={{
										padding: 15,
										background: val == 6 ? 'white' : '',
										cursor: 'pointer',
									}}
									display='flex'
									mt={'10px'}>
									<img
										src={credit}
										alt='credit'
										style={{ width: '30px', height: '30px' }}></img>
									<Box ml={'15px'}>
										<TitleText textStyle={{ fontSize: 16 }}>EMI</TitleText>
										<BodyText textStyle={{ fontSize: 12 }}>
											No Cost EMI available
										</BodyText>
									</Box>
								</Box>
							</Grid>
							<Grid item xs={12} md={8} lg={8}>
								<CheckoutForm value={val} />
								{/* <CheckoutForm /> */}
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={12} md={4} lg={4} style={{ marginTop: 20 }}>
						<Box style={{ position: 'sticky', top: '94px' }}>
							<Box
								style={{
									borderRadius: '10px',
									boxShadow: '0 3px 30px 0 rgb(0 0 0 / 10%)',
									backgroundColor: '#fff',
									padding: '15px 20px',
								}}>
								<Box
									display='flex'
									justifyContent='space-between'
									alignItems={'center'}>
									<TitleText textStyle={{ fontSize: 16 }}>
										Your Booking
									</TitleText>
									<BodyText textStyle={{ fontSize: 12, color: '#9b9b9b' }}>
										ROUND TRIP FLIGHT
									</BodyText>
								</Box>
								<Box>
									<BodyText textStyle={{ color: '#4a4a4a', fontSize: 12 }}>
										Tue, 22 Mar'22
									</BodyText>
								</Box>
								<Box display='flex' justifyContent='space-between' mt={'10px'}>
									<img src={spice} alt='spice'></img>
									<Box>
										<TitleText>2:15 AM</TitleText>
										<BodyText textStyle={{ fontWeight: 600 }}>Bangkok</BodyText>
									</Box>
									<Box>
										<TitleText>23h 20m</TitleText>
										<BodyText textStyle={{ fontWeight: 600 }}>
											1 Stop(s)
										</BodyText>
									</Box>
									<Box>
										<TitleText>2:15 AM</TitleText>
										<BodyText textStyle={{ fontWeight: 600 }}>Bangkok</BodyText>
									</Box>
								</Box>
								<Divider style={{ marginTop: 10 }} />
								<Box display='flex' justifyContent='space-between' mt={'10px'}>
									<img src={spice} alt='spice'></img>
									<Box>
										<TitleText>2:15 AM</TitleText>
										<BodyText textStyle={{ fontWeight: 600 }}>Bangkok</BodyText>
									</Box>
									<Box>
										<TitleText>23h 20m</TitleText>
										<BodyText textStyle={{ fontWeight: 600 }}>
											1 Stop(s)
										</BodyText>
									</Box>
									<Box>
										<TitleText>2:15 AM</TitleText>
										<BodyText textStyle={{ fontWeight: 600 }}>Bangkok</BodyText>
									</Box>
								</Box>
								<Divider style={{ marginTop: 10 }} />
								<Box display='flex' mt={'10px'}>
									<img
										src={icons}
										alt='icons'
										style={{ width: 30, height: 30 }}
									/>
									<Box ml={'5px'}>
										<TitleText textStyle={{ fontSize: 16 }}>
											Traveler(s)
										</TitleText>
										<BodyText textStyle={{ fontSize: 12 }}>
											1.Nitish Kumar (M, Adult) nitis@gmail.com | +91-8093282838
										</BodyText>
									</Box>
								</Box>
							</Box>
							<Box
								mt={'20px'}
								style={{
									borderRadius: '10px',
									boxShadow: '0 3px 30px 0 rgb(0 0 0 / 10%)',
									backgroundColor: '#fff',
									padding: '15px 20px',
								}}>
								<Box
									display='flex'
									justifyContent='space-between'
									alignItems={'center'}>
									<TitleText textStyle={{ fontSize: 16 }}>
										Fare Summary
									</TitleText>
									<BodyText textStyle={{ fontSize: 12, color: '#9b9b9b' }}>
										View Details
									</BodyText>
								</Box>
								<Divider style={{ marginTop: 10 }} />
								<Box
									display='flex'
									justifyContent='space-between'
									alignItems={'center'}>
									<TitleText textStyle={{ fontSize: 16 }}>Fare </TitleText>
									<BodyText textStyle={{ fontSize: 13, fontWeight: 600 }}>
										Rs 9999
									</BodyText>
								</Box>
								<Box
									display='flex'
									justifyContent='space-between'
									alignItems={'center'}>
									<TitleText textStyle={{ fontSize: 16 }}>Others </TitleText>
									<BodyText textStyle={{ fontSize: 13, fontWeight: 600 }}>
										Rs 9999
									</BodyText>
								</Box>
								<Box
									mt={'10px'}
									display='flex'
									justifyContent='space-between'
									alignItems={'center'}>
									<Box>
										<TitleText textStyle={{ fontSize: 20 }}>
											Total Due{' '}
										</TitleText>
										<BodyText>Convenience fee added</BodyText>
									</Box>
									<BodyText
										textStyle={{
											fontSize: 16,
											color: 'black',
											fontWeight: 700,
										}}>
										Rs 85967
									</BodyText>
								</Box>
							</Box>
						</Box>
					</Grid>
				</Grid>
			</Container>
		</>
	);
};

export default CheckoutPage;
